import { supabase } from "@/integrations/supabase/client";

const CRM_ENDPOINT = "https://pjegrpfqdezirkcepsmy.supabase.co/functions/v1/web-lead";

export type CRMLead = {
  company_name?: string | null;
  contact_name?: string | null;
  email?: string | null;
  phone?: string | null;
  country?: string | null;
  division?: "retail" | "industrial" | "medical";
  message?: string | null;
  /** Qualification, attribution and anti-spam fields (see leadSubmit.ts). */
  [extra: string]: unknown;
};

export async function forwardLeadToCRM(payload: CRMLead) {
  const body = { division: "retail" as const, ...payload };

  // 1) Vía backend (evita bloqueos de CORS / adblockers en el navegador)
  try {
    const { data, error } = await supabase.functions.invoke("crm-forward", { body });
    if (!error && (data as { ok?: boolean; skipped?: boolean } | null)) {
      const d = data as { ok?: boolean; skipped?: boolean };
      if (d.ok || d.skipped) return;
    }
  } catch {
    /* seguimos al fallback */
  }

  // 2) Fallback directo desde el cliente (sin campos internos de antispam)
  try {
    const { hp: _hp, elapsed_ms: _e, ...clean } = body as Record<string, unknown>;
    await fetch(CRM_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(clean),
    });
  } catch {
    /* nunca bloquear el formulario */
  }
}
